export const calculateColor = (value, min, max) => {
  const scale = (value - min) / (max - min);
  const r = Math.round((1 - scale) * 255);
  const g = Math.round(scale * 255);
  const b = 0;
  return `rgb(${r},${g},${b})`;
};

// Returns a function that returns the color of a node based on the color key
export function nodeColorFunction(colorKey) {
  const nodeColor = node => {
    if (!node.color) {
      return '#BBBBBB'; // Default color if node.color doesn't exist
    }
    if (typeof node.color === 'string') {
      return node.color; // Use the string color directly
    }
    return node.color[colorKey] || '#BBBBBB'; // Use the selected color key or default
  };

  return nodeColor;
};
